var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Globe = function Globe(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.726 2.026a1.003 1.003 0 0 0-.347-.019 10.192 10.192 0 0 0-.758 0 1.002 1.002 0 0 0-.347.019C6.09 2.398 2 6.721 2 12s4.09 9.602 9.274 9.974c.113.026.23.033.347.019a10.161 10.161 0 0 0 .758 0c.117.014.235.007.348-.019C17.91 21.602 22 17.279 22 12s-4.09-9.602-9.274-9.974ZM9.625 4.359A8.021 8.021 0 0 0 5.07 8h3.302a18 18 0 0 1 1.253-3.641ZM10.43 8c.35-1.354.876-2.66 1.57-3.885A15.998 15.998 0 0 1 13.57 8h-3.14Zm-2.396 2H4.252A8.015 8.015 0 0 0 4 12c0 .69.088 1.36.252 2h3.782a17.999 17.999 0 0 1 0-4Zm2.014 4a16.004 16.004 0 0 1 0-4h3.904a15.999 15.999 0 0 1 0 4h-3.904Zm-1.676 2H5.07a8.021 8.021 0 0 0 4.555 3.642A18 18 0 0 1 8.372 16ZM12 19.885A16.002 16.002 0 0 1 10.43 16h3.14A15.998 15.998 0 0 1 12 19.885Zm2.375-.244A8.021 8.021 0 0 0 18.93 16h-3.302a18 18 0 0 1-1.253 3.642ZM15.966 14h3.782c.165-.64.252-1.31.252-2s-.087-1.36-.252-2h-3.782a17.98 17.98 0 0 1 0 4Zm-.338-6h3.302a8.021 8.021 0 0 0-4.555-3.641A17.998 17.998 0 0 1 15.628 8Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Globe;